
import { Button } from "@/components/ui/button";
import type { SavedSignature } from "@/types/signatures";

interface SignatureDownloaderProps {
  signature: SavedSignature;
  onDownload: (signature: SavedSignature, format: 'svg' | 'png') => void;
}

export const SignatureDownloader = ({ signature, onDownload }: SignatureDownloaderProps) => {
  return (
    <div className="flex gap-2">
      <Button
        variant="secondary"
        size="sm"
        onClick={() => onDownload(signature, 'svg')}
        className="flex items-center gap-1 rounded-full"
      >
        <span>SVG</span>
        <svg 
          width="16" 
          height="16" 
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          className="text-current stroke-current"
        >
          <path 
            d="M10.101 4C11.3636 2.76281 13.0927 2 15 2C18.866 2 22 5.13401 22 9C22 10.9073 21.2372 12.6365 19.9999 13.899M16 15C16 18.866 12.866 22 9 22C5.13401 22 2 18.866 2 15C2 11.134 5.13401 8 9 8C12.866 8 16 11.134 16 15Z" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
        <span>2</span>
      </Button>
      <Button
        variant="secondary"
        size="sm"
        onClick={() => onDownload(signature, 'png')}
        className="flex items-center gap-1 rounded-full"
      >
        <span>PNG</span>
      </Button>
    </div>
  );
};
